import { useTranslation } from 'react-i18next';

export function usePiecesPerBundleUnit(): string {
  const { t } = useTranslation('cart');
  return t('cart.pieces_per_bundle_unit', { bundle: t('cart.bundles_one') });
}
